// Env var schema, split into two groups:
// - `settings`: non-secret config (URLs, domains) — safe to commit in .env* files.
// - `secrets`: keys, tokens, licences — must never be committed; live in config/secrets.enc.
// `optional` must mean "provably absent in a named environment", never "wasn't sure".

const required = { required: true }
const optional = { required: false }

// Non-secret config: URLs and domains. Safe to commit in .env* files.
const settings = {
  VITE_AUTH0_DOMAIN: required,
  VITE_IRWIN_BASE_URL: required,
  VITE_IRWIN_APP_URL: required,
  VITE_FACTSET_AUTH_DOMAIN: optional, // absent from .env.production and .env.test
  VITE_FACTSET_BASE_URL: optional, // absent from .env and .env.test; read into factset.baseUrl but no consumer
  VITE_FEATURE_FLAGS_BASE_URL: optional, // only in .env.development; other modes fall back to irwin.baseUrl
  VITE_VERSION: optional, // read by rollbar.js but set in no env file and no CI job today
  VITE_FACTSET_OIDC_AUTHORITY: optional, // Kong/LIMA: absent when feature is disabled
  VITE_KONG_LIMA_BASE_URL: optional, // Kong/LIMA: absent when feature is disabled
}

// Secrets and identifiers: keys, tokens, licences.
const secrets = {
  VITE_AUTH0_CLIENT_ID: required,
  VITE_FEATURE_FLAGS_KEY: required,
  VITE_MUI_DATAGRID_KEY: required,
  VITE_GEOPLACES_API_KEY: optional, // absent locally and in the CI test job; build jobs get it from the geoplaces-key:* dotenv artifact
  VITE_GMAPS_KEY: optional, // unused by src/; declared only so check-env can reject it from tracked .env
  VITE_FACTSET_OIDC_CLIENT_ID: optional, // Kong/LIMA: public OAuth2 client ID, but kept out of tracked .env files
}

export const envSchema = { ...settings, ...secrets }
export const settingKeys = Object.keys(settings)
